// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1715":"3787c25b","4741":"50580413","5791":"0a32dda8","7082":"3b53517f","9418":"4c1d0f70"}[chunkId] + ".chunk.css";
};